import * as React from "react";
import {useTranslation} from "react-i18next";
import {useCustomerContext} from "../customer/CustomerContextProvider/CustomerContextProvider";
import "./Breadcrumb.scss";
import {CheckoutStep} from "./Checkout";
import {useCheckoutViewContext} from "./CheckoutContextProvider/CheckoutViewContextProvider";
import {isAmazonLoggedIn} from "../lib/payments/AmazonPayLibrary";

const Breadcrumb: React.FC = () => {
  const {t} = useTranslation("checkout");
  const checkoutView = useCheckoutViewContext();
  const {customer} = useCustomerContext();
  const {gotoStep, step} = checkoutView;

  const checkoutSteps = [
    CheckoutStep.LOGIN,
    CheckoutStep.ADDRESS,
    CheckoutStep.SHIPPING,
    CheckoutStep.PAYMENT,
    CheckoutStep.SUMMARY,
  ];

  const Crumb: React.FC<ICrumbProps> = (props) => {
    const {view, title} = props;

    const checkoutViewIndex = checkoutSteps.indexOf(view);
    const stepIndex = checkoutSteps.indexOf(step);

    let className = "";

    const breadcrumbDisabled = checkoutViewIndex === 0 && (customer.isLoggedIn || isAmazonLoggedIn());
    const isPreviousStep = checkoutViewIndex === stepIndex - 1;

    if (stepIndex === checkoutViewIndex) {
      className = BreadcrumbState.ACTIVE;
    } else if (stepIndex > checkoutViewIndex) {
      className = BreadcrumbState.DONE;

      if (breadcrumbDisabled) {
        className += " " + BreadcrumbState.INACTIVE;
      }
    } else if (stepIndex < checkoutViewIndex) {
      className = BreadcrumbState.PENDING;
    }

    if (isPreviousStep) {
      className += " " + BreadcrumbState.RECENT;
    }

    return (
      <div className={className}>
        <span
          onClick={() => {
            if (stepIndex > checkoutViewIndex && !breadcrumbDisabled) {
              gotoStep(view);
            }
          }}
        >
          {title}
        </span>
      </div>
    );
  };

  return (
    <div className="BreadCrumb reduced-width">
      <Crumb title={t("Login")} view={CheckoutStep.LOGIN} />
      <Crumb title={t("Adresse")} view={CheckoutStep.ADDRESS} />
      <Crumb title={t("Versand")} view={CheckoutStep.SHIPPING} />
      <Crumb title={t("Zahlung")} view={CheckoutStep.PAYMENT} />
      <Crumb title={t("Prüfen")} view={CheckoutStep.SUMMARY} />
    </div>
  );
};

export default Breadcrumb;

interface ICrumbProps {
  title: string;
  view: CheckoutStep;
}

enum BreadcrumbState {
  ACTIVE = "Active",
  DONE = "Done",
  INACTIVE = "Inactive",
  PENDING = "Pending",
  RECENT = "Recent",
}
